import { render, staticRenderFns } from "./Jhyj.vue?vue&type=template&id=203e3002&scoped=true"
import script from "./Jhyj.vue?vue&type=script&lang=js"
export * from "./Jhyj.vue?vue&type=script&lang=js"
import style0 from "./Jhyj.vue?vue&type=style&index=0&id=203e3002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e3002",
  null
  
)

export default component.exports